import styled from '@emotion/styled';
import { colors, fonts, radii, breakpoints } from '../../ui';
import DistanceCollectionButtons from '../Refraction/DistanceCollectionButtons';

// "Collected Distances for Positions" (Figma session/17 left): Position 1/2/3, each with the
// captured distance, [Track Distance] and [Capture Distance].

const Title = styled.h3`
  margin: 0 0 12px;
  text-align: center;
  font-family: ${fonts.family};
  font-size: 18px;
  font-weight: 600;
  color: ${colors.slate[600]};
  @media (max-width: ${breakpoints.phone - 1}px) {
    font-size: 15px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  @media (max-width: ${breakpoints.phone - 1}px) {
    gap: 8px;
  }
`;

const Position = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: ${radii.card}px;
  background: ${({ selected }) => (selected ? colors.brand[50] : 'transparent')};
  box-shadow: ${({ selected }) => (selected ? `inset 0 0 0 1px ${colors.brand[200]}` : 'none')};
  font-family: ${fonts.family};
  .label {
    font-size: 13px;
    font-weight: ${({ selected }) => (selected ? 700 : 500)};
    color: ${({ selected }) => (selected ? colors.primary : colors.slate[600])};
  }
  .value {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid ${colors.slate[200]};
    border-radius: ${radii.input}px;
    background: ${colors.slate[100]};
    color: ${colors.slate[500]};
    font-size: 15px;
    font-weight: 600;
  }
  .value.has {
    background: #fff;
    color: ${colors.slate[800]};
  }
  @media (max-width: ${breakpoints.phone - 1}px) {
    padding: 6px 2px;
    button {
      font-size: 11px;
      padding: 0 4px;
      white-space: normal;
      line-height: 1.1;
    }
  }
`;

const RefractionTable = ({ positionData, setPositionData, selectedPosition }) => (
  <div data-testid='refraction-positions'>
    <Title>Collected Distances for Positions</Title>
    <Grid>
      {[1, 2, 3].map((num) => {
        const distance = positionData[num]?.distance;
        const selected = num === +selectedPosition;
        return (
          <Position key={`position-${num}`} selected={selected}>
            <span className='label'>{`Position ${num}`}</span>
            <span className={`value${distance ? ' has' : ''}`} aria-label={`Position ${num} distance`}>
              {distance ? `${distance}mm` : '--'}
            </span>
            <DistanceCollectionButtons positionIndex={num} positionData={positionData} setPositionData={setPositionData} selectedPosition={selectedPosition} />
          </Position>
        );
      })}
    </Grid>
  </div>
);

export default RefractionTable;
